import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import SearchSelectBox from "../../../components/SearchSelectBox";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import useCustomValidation from "../validationSchema";
import { getLeadContact, editLeadContact } from "../../../api/leadContacts";
import { getStatusLeadContacts, getStatusLeadContact } from "../../../api/statusLeadContact";
import { getLeads, getLead } from "../../../api/lead";

const EditLeadContacts = () => {
    const { t } = useTranslation();
    const { addLeadContactSchema } = useCustomValidation();
    const navigate = useNavigate();
    const { id } = useParams();

    const [leadContactData, setLeadContactData] = useState(null);
    const leadContactId = localStorage.getItem("leadContactId");
    const { setData, loading, error, success } = useResponse(editLeadContact, () => {
        navigate(`/leads/show/${leadContactId}`);
    });

    useEffect(() => {
        const fetchLeadContact = async () => {
            try {
                const res = await getLeadContact(id);
                const data = res?.data;
                let leadOption = null;
                let statusOption = null;
                console.log("datadata", data);
                const leadRes = await getLead(data.leadId);
                leadOption = {
                    value: leadRes?.data?.id,
                    label: leadRes?.data?.name,
                };


                const statusRes = await getStatusLeadContact(data.statusLeadContactId._id);
                statusOption = {
                    value: statusRes?.data?.id,
                    label: statusRes?.data?.name,
                };


                setLeadContactData({
                    type: data.type || "",
                    notes: data.notes || "",
                    potentialBudget: data.potentialBudget || "",
                    statusLeadContactId: statusOption,
                    leadId: leadOption,
                });
            } catch (err) {
                console.error("Failed to fetch lead contact data", err);
            }
        };

        fetchLeadContact();
    }, [id]);
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: leadContactData || {
            type: "",
            notes: "",
            potentialBudget: "",
            statusLeadContactId: null,
            leadId: null,
        },
        validationSchema: addLeadContactSchema,
        onSubmit: (values) => {
            const updatedData = {
                type: values.type,
                notes: values.notes,
                potentialBudget: values.potentialBudget,
                statusLeadContactId: values.statusLeadContactId?.value,
                leadId: values.leadId?.value,
            };
            setData({ id, data: updatedData, type: "edit" });
        },
    });

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title={`${t("btns.Edit")} ${t("Lead Contact")}`} />

                <Form
                    className="needs-validation"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                    }}
                >
                    <Row>
                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Type")}</Label>
                                <Input
                                    name="type"
                                    placeholder={t("Type")}
                                    type="text"
                                    onChange={validation.handleChange}
                                    value={validation.values.type}
                                    invalid={!!(validation.touched.type && validation.errors.type)}
                                />
                                <FormFeedback>{validation.errors.type}</FormFeedback>
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Potential Budget")}</Label>
                                <Input
                                    name="potentialBudget"
                                    placeholder={t("Potential Budget")}
                                    type="number"
                                    onChange={validation.handleChange}
                                    value={validation.values.potentialBudget}
                                    invalid={!!(validation.touched.potentialBudget && validation.errors.potentialBudget)}
                                />
                                <FormFeedback>{validation.errors.potentialBudget}</FormFeedback>
                            </FormGroup>
                        </Col>

                        <Col md="12">
                            <FormGroup className="mb-3">
                                <Label>{t("Notes")}</Label>
                                <Input
                                    name="notes"
                                    placeholder={t("Notes")}
                                    type="textarea"
                                    rows={4}
                                    onChange={validation.handleChange}
                                    value={validation.values.notes}
                                    invalid={!!(validation.touched.notes && validation.errors.notes)}
                                />
                                <FormFeedback>{validation.errors.notes}</FormFeedback>
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Status")}</Label>
                                <SearchSelectBox
                                    api={getStatusLeadContacts}
                                    name="statusLeadContactId"
                                    placeholder={t("Select Status")}
                                    value={validation.values.statusLeadContactId}
                                    label="name"
                                    setValue={(value) => validation.setFieldValue("statusLeadContactId", value)}
                                    error={!!(
                                        validation.touched.statusLeadContactId &&
                                        validation.errors.statusLeadContactId
                                    )}
                                />
                                {validation.touched.statusLeadContactId && validation.errors.statusLeadContactId && (
                                    <div className="text-danger mt-1">{validation.errors.statusLeadContactId}</div>
                                )}
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Lead")}</Label>
                                <SearchSelectBox
                                    api={getLeads}
                                    name="leadId"
                                    placeholder={t("Select Lead")}
                                    value={validation.values.leadId}
                                    label="name"
                                    setValue={(value) => validation.setFieldValue("leadId", value)}
                                    error={
                                        !!(validation.touched.leadId && validation.errors.leadId)
                                    }
                                />
                                {validation.touched.leadId && validation.errors.leadId && (
                                    <div className="text-danger mt-1">{validation.errors.leadId}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>

                    <FormButtonHandler btnTxt={t("Update")} loading={loading} />

                    <ResultHandler
                        error={error}
                        success={success}
                        successMsg={t("Updated Successfully!")}
                    />
                </Form>
            </Container>
        </div>
    );
};

export default EditLeadContacts;
